export default new class ButtonChangeQuantity {
    constructor() {
      this.inputWrapSelector = 'button-change-quantity';
      this.inputSelector = 'button-change-quantity__input';
      this.increaseQuantityBtnSelector = 'cart-product__change-btn_increase';
      this.decreaseQuantityBtnSelector = 'cart-product__change-btn_decrease';

      this.handler();
    }
  
    handler() {
      const inputs = document.querySelectorAll(`.${this.inputWrapSelector}`);

      inputs.forEach(inputWrap => {
        const input = inputWrap.querySelector(`.${this.inputSelector}`);

        const increaseBtn = inputWrap.querySelector(`.${this.increaseQuantityBtnSelector}`);
        const decreaseBtn = inputWrap.querySelector(`.${this.decreaseQuantityBtnSelector}`);

        input.addEventListener('change', (e) => {
          const step = Number(input.getAttribute('step'));
          const newVal = e.target.valueAsNumber;
          const x = newVal % step;

          console.log(x, newVal, step)

          if (x > 0) {
            input.value = newVal - x + step
          }
        });

        increaseBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const step = Number(input.getAttribute('step'));
          const max = Number(input.getAttribute('max'));
          const val = input.valueAsNumber;

          console.log(step, max, val)

          input.value = (val - 1) + step;
          
        });

        decreaseBtn.addEventListener('click', (e) => {
          e.preventDefault();
          const step = Number(input.getAttribute('step'));

          if (input.value > step) {
            input.value = input.value - step + 1; 
          } else if (input.value > step * 2) {
            input.value = input.value - step + 1; 
            decreaseBtn.setAttribute('disabled', 'disabled');
          }
        });
      });
    }
}
  